// extracted by mini-css-extract-plugin
export default {"container":"offer-label_container__qkxuh","content":"offer-label_content__s0bi6","label":"offer-label_label__PsKS9"};